import labels from 'src/../config/label'

export function findLovType (boxType) {
  return (boxType.indexOf('codempid') >= 0) ? 'codempid'
         : (boxType.indexOf('codemp9') >= 0) ? 'codemp9'
         : (boxType.indexOf('codpos') >= 0) ? 'codpos'
         : (boxType.indexOf('codapp') >= 0) ? 'codapp'
         : (boxType.indexOf('codcalen') >= 0) ? 'codcalen'
         : (boxType.indexOf('codcours') >= 0) ? 'codcours'
         : (boxType.indexOf('nummemo') >= 0) ? 'nummemo'
         : (boxType.indexOf('numreq') >= 0) ? 'numreq'
         : (boxType.indexOf('codaplvl') >= 0) ? 'codaplvl'
         : (boxType.indexOf('grdscor') >= 0) ? 'grdscor'
         : (boxType.indexOf('codshift') >= 0) ? 'codshift'
         : (boxType.indexOf('codroom') >= 0) ? 'codroom'
         : (boxType.indexOf('codasset') >= 0) ? 'codasset'
         : (boxType.indexOf('codform') >= 0) ? 'codform'
         : (boxType.indexOf('codcompy') >= 0) ? 'codcompy'
         : (boxType.indexOf('numappl') >= 0) ? 'numappl'
         : (boxType.indexOf('batchno') >= 0) ? 'batchno'
         : (boxType.indexOf('costcent') >= 0) ? 'costcent'
         : (boxType.indexOf('codbrlc') >= 0) ? 'codbrlc'
         : (boxType.indexOf('codtency') >= 0) ? 'codtency'
         : (boxType.indexOf('codedlv') >= 0) ? 'codedlv'
         : (boxType.indexOf('codjob') >= 0) ? 'codjob'
         : (boxType.indexOf('codempmt') >= 0) ? 'codempmt'
         : (boxType.indexOf('typemp') >= 0) ? 'typemp'
         : (boxType.indexOf('typpayroll') >= 0) ? 'typpayroll'
         : (boxType.indexOf('codinst') >= 0) ? 'codinst'
         : (boxType.indexOf('staemp') >= 0) ? 'staemp'
         : (boxType.indexOf('coddomcl') >= 0) ? 'coddomcl'
         : (boxType.indexOf('codprovr') >= 0) ? 'codprovr'
         : (boxType.indexOf('typleave') >= 0) ? 'typleave'
         : (boxType.indexOf('courstrain') >= 0) ? 'courstrain'
         : (boxType.indexOf('codempstapp') >= 0) ? 'codempstapp'
         : ''
}

export function checkBoxType (type, boxType) {
  switch (type) {
    case 'DATE':
      return boxType === 'dtestrt' || boxType === 'dtereqst' || boxType === 'dteapprst' || boxType === 'dteworkst' ||
             boxType === 'dteend' || boxType === 'dtereqen' || boxType === 'dteappren' || boxType === 'dteworken' ||
             boxType === 'dtetarg' || boxType === 'dteappr' || boxType === 'dtereserv' || boxType === 'dteappoist' ||
             boxType === 'dteappoien' || boxType === 'dteeffest' || boxType === 'dteeffeen' || boxType === 'entrydte_st' ||
             boxType === 'entrydte_en' || boxType === 'dteopertst' || boxType === 'dteoperten' || boxType === 'dtework'
    case 'TIME':
      return boxType === 'timstrt' || boxType === 'timend'
    case 'INPUTTEXT':
      return boxType === 'target' || boxType === 'mtrvalue' || boxType === 'namcust' || boxType === 'codcust' || boxType === 'zipcode'
    case 'INPUTNUMBER':
      return boxType === 'numclseq' || boxType === 'numtime' || boxType === 'kpiitem' ||
             boxType === 'kpiwgt'
    case 'LOVCODCOMP':
      return boxType === 'codcomp' || boxType === 'codcomp2'
    case 'LOVCODCOMP2':
      return boxType === 'codcomp3'
    case 'LOV':
      return boxType === 'codempid' || boxType === 'codpos' || boxType === 'codapp' || boxType === 'courstrain' ||
             boxType === 'codcalen' || boxType === 'codcours' || boxType === 'codcours2' || boxType === 'nummemo' ||
             boxType === 'numreq' || boxType === 'codaplvl' || boxType === 'grdscor' || boxType === 'codempid2' ||
             boxType === 'codempid3' || boxType === 'codempid4' || boxType === 'codshift' || boxType === 'codroom' ||
             boxType === 'codasset' || boxType === 'codform' || boxType === 'codcompy' || boxType === 'numappl' ||
             boxType === 'numapplst' || boxType === 'numapplen' || boxType === 'batchno' || boxType === 'costcent' ||
             boxType === 'codbrlc' || boxType === 'codtency' || boxType === 'codedlv' || boxType === 'codjob' ||
             boxType === 'codempmt' || boxType === 'typemp' || boxType === 'typpayroll' || boxType === 'codinst' ||
             boxType === 'staemp' || boxType === 'coddomcl' || boxType === 'codprovr' || boxType === 'typleave' ||
             boxType === 'codempstapp' || boxType === 'codemp9' || boxType === 'codemp93'
    case 'DROPDOWN':
      return boxType === 'staappr' || boxType === 'staapprAll' || boxType === 'staapprHres3cu' || boxType === 'mtrunit' || boxType === 'period'
    case 'DROPDOWNYEAR':
      return boxType === 'year'
    case 'DROPDOWNMONTH':
      return boxType === 'month'
    case 'LOGICALSTMT':
      return boxType === 'syncond'
    default:
      return false
  }
}

export function genDropdowns (boxType) {
  let dropdowns = {}
  switch (boxType) {
    case 'staappr':
      dropdowns = labels.statusApprove[this.nowLang]
      break
    case 'staapprAll':
      dropdowns = labels.statusApproveAll[this.nowLang]
      break
    case 'staapprHres3cu':
      dropdowns = labels.statusApproveHres3cu[this.nowLang]
      break
    case 'period':
      dropdowns = labels.period[this.nowLang]
      break
  }
  return dropdowns
}

export const searchBoxLabels = {
  en: {
    dtereqst: 'Date Request From',
    dtereqen: 'to',
    dteapprst: 'Date Approve From',
    dteappren: 'to',
    dteopertst: 'Date Operate From',
    dteoperten: 'to',
    staappr: 'Approve Status',
    staapprAll: 'Approve Status',
    staapprHres3cu: 'Approve Status',
    dtestrt: 'Date Start From',
    dteend: 'to',
    year: 'For Year',
    month: 'For Month',
    codcomp: 'Department',
    codcomp2: 'or Department',
    codcomp3: 'Department',
    codpos: 'Position',
    codempid: 'Employee Code',
    codempid4: 'Employee Code',
    codempid3: 'or Employee Code',
    codemp9: 'Employee Code',
    codemp93: 'or Employee Code',
    codcalen: 'Group Code',
    syncond: 'Search condition',
    codapp: 'Type of function',
    nummemo: 'For Memo. No.',
    codcours: 'or Course Code',
    codcours2: 'Course Code',
    numclseq: 'Class No.',
    numreq: 'Personnel req. no.',
    numtime: 'App. No.',
    kpiitem: 'Description of KPI',
    kpiwgt: 'Weight',
    target: 'Target Value',
    dtetarg: 'Target Date',
    mtrunit: 'Units',
    mtrvalue: 'Metric Value',
    codcust: 'Customer Code',
    namcust: 'Customer Name',
    codprovr: 'Province',
    typleave: 'Type of Leave',
    zipcode: 'Zipcode',
    codaplvl: 'Appraisal Group',
    period: 'Period',
    codempid2: 'Approve By',
    dteappr: 'Approve Date',
    codshift: 'Shift Code',
    dtework: 'Date',
    dteworkst: 'From Date',
    dteworken: 'To Date',
    dtereserv: 'For Date',
    timstrt: 'Available Time From',
    timend: 'To',
    codroom: 'Room No.',
    codasset: 'Asset Type',
    codcompy: 'Codcompy',
    dteappoist: 'Interview Date',
    numappl: 'Application No.',
    numapplst: 'Application No.',
    dteappoien: 'To',
    numapplen: 'To',
    codform: 'Assessment Form',
    dteeffest: 'Date Effect From',
    dteeffeen: 'To',
    entrydte_st: 'Entry Date Start',
    entrydte_en: 'To',
    batchno: 'or Batch No.',
    costcent: 'Cost Center',
    codbrlc: 'Branch',
    courstrain: 'or Course Code',
    codempstapp: 'Employee Code'
  },
  th: {
    dtereqst: 'วันที่ขอ ตั้งแต่',
    dtereqen: 'ถึง',
    dteapprst: 'วันที่อนุมัติ ตั้งแต่',
    dteappren: 'ถึง',
    dteopertst: 'วันที่ดำเนินการ ตั้งแต่',
    dteoperten: 'ถึง',
    staappr: 'สถานะการอนุมัติ',
    staapprAll: 'สถานะการอนุมัติ',
    staapprHres3cu: 'สถานะ',
    dtestrt: 'วันที่เริ่มต้น',
    dteend: 'ถึง',
    year: 'สำหรับปี',
    month: 'สำหรับเดือน',
    codcomp: 'หน่วยงาน',
    codcomp2: 'หรือ หน่วยงาน',
    codcomp3: 'หน่วยงาน',
    codpos: 'ตำแหน่ง',
    codempid: 'รหัสพนักงาน',
    codempid4: 'รหัสพนักงาน',
    codempid3: 'หรือ รหัสพนักงาน',
    codemp9: 'รหัสพนักงาน',
    codemp93: 'หรือ รหัสพนักงาน',
    codcalen: 'กลุ่มพนักงาน',
    syncond: 'Criteria ในการเลือกพนักงาน',
    codapp: 'ประเภทเรื่อง',
    nummemo: 'อ้างถึง Memo. No.',
    codcours: 'หรือ หลักสูตร',
    codcours2: 'หลักสูตร',
    numclseq: 'รุ่นที่',
    numreq: 'เลขที่ใบขออนุมัติ',
    numtime: 'ครั้งที่',
    kpiitem: 'รายละเอียด KPI',
    kpiwgt: 'น้ำหนัก',
    target: 'เป้าหมายที่กำหนด',
    dtetarg: 'วันที่กำหนดแล้วเสร็จ',
    mtrunit: 'หน่วย',
    mtrvalue: 'มูลค่า',
    codcust: 'รหัสลูกค้า',
    namcust: 'ชื่อลูกค้า',
    codprovr: 'จังหวัด',
    typleave: 'ประเภทการลาที่ต้องการสอบถาม',
    zipcode: 'รหัสไปรษณีย์',
    codaplvl: 'กลุ่มประเมิน',
    period: 'งวด',
    codempid2: 'อนุมัติโดย',
    dteappr: 'วันที่อนุมัติ',
    codshift: 'รหัสกะ',
    dtework: 'วันที่',
    dteworkst: 'ตั้งแต่วันที่',
    dteworken: 'ถึง',
    dtereserv: 'สำหรับวัน',
    timstrt: 'ช่วงเวลาที่ว่าง ตั้งแต่',
    timend: 'ถึง',
    codroom: 'ห้องประชุม',
    codasset: 'ประเภททรัพย์สิน',
    codcompy: 'รหัสบริษัท',
    dteappoist: 'วันที่สัมภาษณ์',
    numappl: 'เลขที่ใบสมัคร',
    numapplst: 'เลขที่ใบสมัคร',
    dteappoien: 'ถึงวันที่',
    numapplen: 'ถึง',
    codform: 'แบบฟอร์มการประเมิน',
    dteeffest: 'วันที่ทดลอง ตั้งแต่',
    dteeffeen: 'ถึง',
    entrydte_st: 'Entry Date ตั้งแต่',
    entrydte_en: 'ถึง',
    batchno: 'หรือ Batch No.',
    costcent: 'Cost Center',
    codbrlc: 'Branch',
    courstrain: 'หรือ หลักสูตร',
    codempstapp: 'รหัสพนักงาน'
  }
}

export function searchComponentGenerator (codapp) {
  let arraySearchs = []
  switch (codapp) {
    case 'demo-searchbox-box-type':
      arraySearchs = [
        'dtestrt',
        'dtereqst',
        'dteapprst',
        'dteend',
        'dtereqen',
        'dteappren',
        'dteopertst',
        'dteoperten',
        'codpos',
        'codempid',
        'staappr',
        'staapprHres3cu',
        'year',
        'month',
        'codcomp',
        'codapp',
        'nummemo',
        'codcours',
        'numclseq',
        'numreq',
        'numtime',
        'codaplvl',
        'period',
        'codempid2',
        'codcompy',
        'dteappoist',
        'dteappoien',
        'numappl',
        'dteeffest',
        'dteeffeen',
        'batchno',
        'courstrain'
      ]
      break
    case 'demo-searchbox-rules':
      arraySearchs = [
        'dtestrt@requiredWhenExist:dteend|date_format:DD/MM/YYYY',
        'dtereqst@requiredWhenExist:dtereqen|date_format:DD/MM/YYYY',
        'dteapprst@requiredWhenExist:dteappren|date_format:DD/MM/YYYY',
        'dteappoist@requiredWhenExist:dteappoien|date_format:DD/MM/YYYY',
        'dteend@requiredWhenExist:dtestrt|date_format:DD/MM/YYYY|after:dtestrt',
        'dtereqen@requiredWhenExist:dtereqst|date_format:DD/MM/YYYY|after:dtereqst',
        'dteappren@requiredWhenExist:dteapprst|date_format:DD/MM/YYYY|after:dteapprst',
        'dteappoien@requiredWhenExist:dteappoist|date_format:DD/MM/YYYY|after:dteappoist',
        'codpos@required',
        'codempid@required',
        'staappr@required',
        'staapprHres3cu@required',
        'year@required',
        'month@required',
        'codapp@required',
        'nummemo@required',
        'codcours@required',
        'numclseq@required',
        'numreq@required',
        'numtime@required',
        'codaplvl@required',
        'period@required',
        'batchno',
        'codtency',
        'codedlv',
        'codjob',
        'codempmt',
        'typemp',
        'typpayroll',
        'codinst',
        'staemp',
        'coddomcl'
      ]
      break
    case 'demo-searchbox-condition':
      arraySearchs = [
        'dtestrt@@demo-searchbox-condition',
        'dtereqst@@demo-searchbox-condition',
        'dteapprst@@demo-searchbox-condition',
        'dteend@@demo-searchbox-condition',
        'dtereqen@@demo-searchbox-condition',
        'dteappren@@demo-searchbox-condition',
        'codpos@@demo-searchbox-condition',
        'codempid@@demo-searchbox-condition',
        'staappr@@demo-searchbox-condition',
        'staapprHres3cu@@demo-searchbox-condition',
        'year@@demo-searchbox-condition',
        'month@@demo-searchbox-condition',
        'codapp@@demo-searchbox-condition',
        'nummemo@@demo-searchbox-condition',
        'codcours@@demo-searchbox-condition',
        'numclseq@@demo-searchbox-condition',
        'numreq@@demo-searchbox-condition',
        'numtime@@demo-searchbox-condition',
        'codaplvl@@demo-searchbox-condition',
        'period@@demo-searchbox-condition',
        'numappl@@demo-searchbox-condition',
        'batchno@@demo-searchbox-condition'
      ]
      break
    case 'demo-lov-codempid':
      arraySearchs = [
        'codempid'
      ]
      break
    case 'demo-lov-codpos':
      arraySearchs = [
        'codpos'
      ]
      break
    case 'demo-lov-codcomp':
      arraySearchs = [
        'codcomp'
      ]
      break
    case 'demo-lov-nummemo':
      arraySearchs = [
        'nummemo'
      ]
      break
    case 'demo-lov-codcours':
      arraySearchs = [
        'codcours'
      ]
      break
    case 'demo-lov-numreq':
      arraySearchs = [
        'numreq'
      ]
      break
    case 'demo-lov-codaplvl':
      arraySearchs = [
        'codaplvl'
      ]
      break
    case 'hrms17e-detail2':
      arraySearchs = [
        'kpiitem',
        'kpiwgt',
        'target',
        'dtetarg',
        'mtrunit',
        'mtrvalue'
      ]
      break
    case 'request':
      arraySearchs = [
        'dtereqst@requiredWhenExist:dtereqen|date_format:DD/MM/YYYY',
        'dtereqen@requiredWhenExist:dtereqst|date_format:DD/MM/YYYY|after:dtereqst'
      ]
      break
    case 'request-subrogate':
      arraySearchs = [
        'codcomp',
        'codempid',
        'dtereqst@requiredWhenExist:dtereqen|date_format:DD/MM/YYYY',
        'dtereqen@requiredWhenExist:dtereqst|date_format:DD/MM/YYYY|after:dtereqst'
      ]
      break
    case 'approve':
      arraySearchs = [
        'dteapprst@requiredWhenExist:dteappren|date_format:DD/MM/YYYY@approve',
        'dteappren@requiredWhenExist:dteapprst|date_format:DD/MM/YYYY|after:dteapprst@approve',
        'staappr@required@approve',
        'codempid'
      ]
      break
    case 'hres3cu':
      arraySearchs = [
        'dteopertst@requiredWhenExist:dteoperten|date_format:DD/MM/YYYY@approve',
        'dteoperten@requiredWhenExist:dteopertst|date_format:DD/MM/YYYY|after:dteopertst@approve',
        'staapprHres3cu@required@approve',
        'codempid'
      ]
      break
    case 'hrms41e':
      arraySearchs = [
        'dteappoist@requiredWhenExist:dteappoien|date_format:DD/MM/YYYY',
        'dteappoien@requiredWhenExist:dteappoist|date_format:DD/MM/YYYY|after:dteappoist',
        'numapplst',
        'numapplen'
      ]
      break
    case 'hres6ae-detail':
      arraySearchs = [
        'dteworkst@required|date_format:DD/MM/YYYY',
        'dteworken@required|date_format:DD/MM/YYYY|after:dteworkst'
      ]
      break
    case 'hrms6ae-detail':
      arraySearchs = [
        'codempid@required',
        'dteworkst@required|date_format:DD/MM/YYYY',
        'dteworken@required|date_format:DD/MM/YYYY|after:dteworkst'
      ]
      break
    case 'hrms18e':
      arraySearchs = [
        'codcomp@requiredAny:codcomp,codcalen',
        'codcalen@requiredAny:codcomp,codcalen',
        'month@required',
        'year@required'
      ]
      break
    case 'hresh1x':
      arraySearchs = [
        'codempid@@hresh1x',
        'dtestrt@required|date_format:DD/MM/YYYY',
        'dteend@required|date_format:DD/MM/YYYY|after:dtestrt'
      ]
      break
    case 'hrms12x':
      arraySearchs = [
        'syncond'
      ]
      break
    case 'hrms13x':
      arraySearchs = [
        'codempid@requiredAny:codempid,codcomp2',
        'codcomp2@requiredAny:codempid,codcomp2',
        'syncond'
      ]
      break
    case 'hrms14x':
      arraySearchs = [
        'codapp@required',
        'dtestrt@required|date_format:DD/MM/YYYY',
        'dteend@required|date_format:DD/MM/YYYY|after:dtestrt',
        'codcomp',
        'codempid3',
        'staapprAll@required'
      ]
      break
    case 'hrms15e':
      arraySearchs = [
        'year@required',
        'numtime@required',
        'codcomp3@requiredWhenNotExist:codemp93',
        'codaplvl@max:4',
        'codemp93@requiredAllWhenNotExistAll:codemp93,codcomp3-codaplvl|max:8'
      ]
      break
    case 'hrms16x':
      arraySearchs = [
        'year@required',
        'numtime@required',
        'codcomp',
        'codpos',
        'codempid3'
      ]
      break
    case 'hrms17e':
      arraySearchs = [
        'year@required',
        'numtime@required',
        'codcomp@requiredWhenNotExist:codempid3',
        'codpos',
        'codempid3@requiredWhenNotExist:codcomp',
        'codempid2@required',
        'dteappr@required'
      ]
      break
    case 'hrms19x':
      arraySearchs = [
        'dtestrt@required|date_format:DD/MM/YYYY',
        'dteend@required|date_format:DD/MM/YYYY|after:dtestrt',
        'codempid@requiredAllWhenNotExistAll:codempid,codcomp2-codcalen',
        'codcomp2@requiredAllWhenNotExistAll:codcomp2,codempid-codcalen',
        'codcalen@requiredAllWhenNotExistAll:codcalen,codempid-codcomp2'
      ]
      break
    case 'hrms27u':
      arraySearchs = [
        'numreq',
        'codpos',
        'dtestrt@required|date_format:DD/MM/YYYY',
        'dteend@required|date_format:DD/MM/YYYY|after:dtestrt'
      ]
      break
    case 'hrms31e':
      arraySearchs = [
        'codcomp@requiredAllWhenExistAny:codcomp,dtestrt-dteend|requiredWhenNotExist:codempstapp',
        'dtestrt@requiredAllWhenExistAny:dtestrt,codcomp-dteend|requiredWhenNotExist:codempstapp|date_format:DD/MM/YYYY',
        'dteend@requiredAllWhenExistAny:dtestrt,codcomp-dtestrt|requiredWhenNotExist:codempstapp|date_format:DD/MM/YYYY|after:dtestrt',
        'codempstapp@requiredAllWhenNotExistAll:codempstapp,codcomp-dtestrt-dteend'
      ]
      break
    case 'hres81x':
      arraySearchs = [
        'year@required',
        'month@required',
        'period@required'
      ]
      break
    case 'hrms74e':
      arraySearchs = [
        'nummemo@requiredWhenNotExist:codcours',
        'codcours@requiredWhenNotExist:nummemo',
        'year@requiredWhenExist:codcours',
        'numclseq@requiredWhenExist:codcours',
        'codcomp'
      ]
      break
    case 'hrms76x':
      arraySearchs = [
        'year@required',
        'codcomp',
        'codpos',
        'codempid3'
      ]
      break
    case 'hrms73e':
      arraySearchs = [
        'year@required',
        'codcours2@required',
        'numclseq@required',
        'codcomp@requiredWhenNotExist:codempid3',
        'codempid3@requiredWhenNotExist:codcomp'
      ]
      break
    case 'hrms75e':
      arraySearchs = [
        'year@required',
        'codempid',
        'codcomp2'
      ]
      break
    case 'hrms75e-detail':
      arraySearchs = [
        'codempid@required'
      ]
      break
    case 'hres7de':
      arraySearchs = [
        'year@required',
        'courstrain',
        'numclseq',
        'dtestrt@requiredWhenExist:dteend|date_format:DD/MM/YYYY',
        'dteend@requiredWhenExist:dtestrt|date_format:DD/MM/YYYY|after:dtestrt'
      ]
      break
    case 'hres7fe':
      arraySearchs = [
        'year@required',
        'codcours',
        'numclseq',
        'dtestrt@requiredWhenExist:dteend|date_format:DD/MM/YYYY',
        'dteend@requiredWhenExist:dtestrt|date_format:DD/MM/YYYY|after:dtestrt'
      ]
      break
    case 'hress1e':
      arraySearchs = [
        'year@required',
        'numtime@required'
      ]
      break
    case 'hres6ae_detail':
      arraySearchs = [
        'dtestrt@required|date_format:DD/MM/YYYY',
        'dteend@required|date_format:DD/MM/YYYY|after:dtestrt'
      ]
      break
    case 'hresz2u':
      arraySearchs = [
        'dtestrt@requiredWhenExist:dteend|date_format:DD/MM/YYYY@approve',
        'dteend@requiredWhenExist:dtestrt|date_format:DD/MM/YYYY|after:dtestrt@approve',
        'staappr@required@approve',
        'batchno',
        'codempid3'
      ]
      break
    case 'hres82e':
      arraySearchs = [
        'codroom',
        'dtereserv@required|date_format:DD/MM/YYYY',
        'timstrt@requiredWhenExist:timend|date_format:HH:mm',
        'timend@requiredWhenExist:timstrt|date_format:HH:mm|after:timstrt'
      ]
      break
    case 'hres83e':
      arraySearchs = [
        'codasset',
        'dtereserv@required|date_format:DD/MM/YYYY',
        'timstrt@requiredWhenExist:timend|date_format:HH:mm',
        'timend@requiredWhenExist:timstrt|date_format:HH:mm|after:timstrt'
      ]
      break
    case 'hres4ax':
      arraySearchs = [
        'codcompy',
        'dteeffest@requiredWhenExist:dteeffeen|date_format:DD/MM/YYYY',
        'dteeffeen@requiredWhenExist:dteeffest|date_format:DD/MM/YYYY|after:dteeffest'
      ]
      break
    case 'hresz1e':
      arraySearchs = [
        'entrydte_st@requiredWhenNotExist:batchno|date_format:DD/MM/YYYY',
        'entrydte_en@requiredWhenNotExist:batchno|date_format:DD/MM/YYYY|after:entrydte_st',
        'batchno@requiredWhenNotExist:entrydte_st,entrydte_en'
      ]
      break
    case 'hrms1ax':
      arraySearchs = [
        'codempid@requiredAllWhenNotExistAll:codempid,codcomp2-codcalen',
        'codcomp2@requiredWhenExist:codcalen',
        'codcalen',
        'dteworkst@required|date_format:DD/MM/YYYY',
        'dteworken@required|date_format:DD/MM/YYYY|after:dteworkst'
      ]
      break
    case 'hrms55x':
      arraySearchs = [
        'codempid4@requiredAny:codempid4,codcomp2',
        'codcomp2@requiredAny:codempid4,codcomp2',
        'dteworkst@required|date_format:DD/MM/YYYY',
        'dteworken@required|date_format:DD/MM/YYYY|after:dteworkst',
        'typleave'
      ]
      break
    case 'hrms55x2':
      arraySearchs = [
        'dtework@required|date_format:DD/MM/YYYY',
        'typleave'
      ]
      break
    case 'hres88e':
      arraySearchs = [
        'dtereqst@required|date_format:DD/MM/YYYY',
        'dtereqen@required|date_format:DD/MM/YYYY|after:dtereqst'
      ]
      break
    case 'hres6oe':
      arraySearchs = [
        'namcust@requiredAny:namcust,codcust,codprovr',
        'codcust@requiredAny:namcust,codcust,codprovr',
        'codprovr@requiredAny:namcust,codcust,codprovr'
      ]
      break
  }
  return generateSearchComponentsByArraySearch(arraySearchs)
}

function generateSearchComponentsByArraySearch (arraySearchs) {
  let searchComponents = []
  for (var search of arraySearchs) {
    var searchArr = search.split('@')
    searchComponents.push({
      boxType: searchArr[0],
      rules: (typeof searchArr[1] !== 'undefined') ? searchArr[1] : '',
      condition: (typeof searchArr[2] !== 'undefined') ? searchArr[2] : ''
    })
  }
  return searchComponents
}



// WEBPACK FOOTER //
// ./src/components/hrmsSearchBox/searchComponents.js